<template>
  <div class="px-0">
    <button class="mx-0 mb-4" @click="printData">列印</button>
    <div style="width: 100%; height: 0px; overflow: hidden">
      <div v-if="Object.keys(listData).length != 0" ref="print">
        <div :style="printTitleStyle">工單履歷</div>
        <div>
          <p :style="titleTextStyle">批號資訊</p>
          <commonTable
            :fields="listData.batchFields"
            :items="listData.batchItems"
          >
            <template #cell(ingotTotalWeight)="data">{{
              isNaN(Number(data.value))
                ? data.value
                : Number(data.value).toLocaleString("en-US")
            }}</template>
          </commonTable>
        </div>
        <div>
          <p :style="titleTextStyle">鑄錠資訊</p>
          <commonTable
            :fields="listData.ingotFields"
            :items="listData.ingotItems"
          >
            <template #cell(weight)="data">{{
              isNaN(Number(data.value))
                ? data.value
                : Number(data.value).toLocaleString("en-US")
            }}</template>
          </commonTable>
        </div>

        <div style="margin-bottom: 1rem">
          <p :style="titleTextStyle">鍛棒資訊</p>
          <!-- <div style="padding: 0.5rem"> -->
          <template v-if="listData.forgeRecord.length == 0">
            <div>
              <div style="margin-bottom: 1rem">
                <commonTable :fields="listData.castingFields" :items="[]">
                </commonTable>
              </div>

              <div style="margin-bottom: 1rem">
                <commonTable :fields="listData.castingDetailFields" :items="[]">
                  <template #thead-top="">
                    <tr>
                      <th style="font-size: 16px" rowspan="2">道次</th>
                      <th style="font-size: 16px" colspan="2">鍛造力(右)</th>
                      <th style="font-size: 16px" colspan="2">鍛造力(左)</th>
                      <th style="font-size: 16px" colspan="2">溫度(A)</th>
                      <th style="font-size: 16px" colspan="2">溫度(B)</th>
                      <th style="font-size: 16px" rowspan="2">時間</th>
                    </tr>
                    <tr>
                      <th style="border-left: 0px; font-size: 16px">最大值</th>
                      <th style="font-size: 16px">平均值</th>
                      <th style="font-size: 16px">最大值</th>
                      <th style="font-size: 16px">平均值</th>
                      <th style="font-size: 16px">最大值</th>
                      <th style="font-size: 16px">最小值</th>
                      <th style="font-size: 16px">最大值</th>
                      <th style="font-size: 16px">最小值</th>
                    </tr>
                  </template>
                </commonTable>
              </div>

              <div style="margin-bottom: 1rem">
                <p :style="titleTextStyle">檢驗資訊</p>
                <div>
                  <table>
                    <thead>
                      <tr>
                        <th v-for="eagerlyField in listData.eagerlyFields">
                          {{ eagerlyField.label }}
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
              </div>

              <div>
                <p :style="titleTextStyle">淬水資訊</p>
                <commonTable
                  :fields="listData.quenchingWaterFields"
                  :items="[]"
                >
                </commonTable>
              </div>
            </div>
          </template>
          <template v-else>
            <template v-for="(item, key) in listData.forgeRecord">
              <div v-if="listData.forgeRecordSelectIndex == key">
                <div style="margin-bottom: 1rem">
                  <commonTable
                    :fields="listData.castingFields"
                    :items="item.castingItems"
                  >
                  </commonTable>
                </div>

                <div style="margin-bottom: 1rem">
                  <commonTable
                    :fields="listData.castingDetailFields"
                    :items="item.castingDetailItems"
                  >
                    <template #thead-top="">
                      <tr>
                        <th style="font-size: 16px" rowspan="2">道次</th>
                        <th style="font-size: 16px" colspan="2">鍛造力右</th>
                        <th style="font-size: 16px" colspan="2">鍛造力左</th>
                        <th style="font-size: 16px" colspan="2">
                          溫度A(&#8451;)
                        </th>
                        <th style="font-size: 16px" colspan="2">
                          溫度B(&#8451;)
                        </th>
                        <th
                          style="font-size: 16px; min-width: 90px"
                          rowspan="2"
                        >
                          時間(分:秒)
                        </th>
                      </tr>
                      <tr>
                        <th style="border-left: 0px; font-size: 16px">
                          最大值
                        </th>
                        <th style="font-size: 16px">平均值</th>
                        <th style="font-size: 16px">最大值</th>
                        <th style="font-size: 16px">平均值</th>
                        <th style="font-size: 16px">最大值</th>
                        <th style="font-size: 16px">最小值</th>
                        <th style="font-size: 16px">最大值</th>
                        <th style="font-size: 16px">最小值</th>
                      </tr>
                    </template>
                  </commonTable>
                </div>

                <div style="margin-bottom: 1rem">
                  <p :style="titleTextStyle">檢驗資訊</p>
                  <div>
                    <table>
                      <thead>
                        <tr>
                          <th v-for="eagerlyField in listData.eagerlyFields">
                            {{ eagerlyField.label }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <template
                          v-for="(eagerlyItem, itemKey) in item.eagerlyItems"
                        >
                          <template
                            v-for="(
                              detailItem, detailKey
                            ) in eagerlyItem.detail"
                          >
                            <tr v-if="detailKey == 0">
                              <td :rowspan="eagerlyItem.detail.length">
                                {{ eagerlyItem.tbm }}
                              </td>
                              <td>{{ detailItem.time }}</td>
                              <td>{{ detailItem.insp_op }}</td>
                              <td>{{ detailItem.inspItem }}</td>
                              <td>{{ detailItem.stdValue }}</td>
                              <td>{{ detailItem.inspValue }}</td>
                              <td>{{ detailItem.result }}</td>
                              <td :rowspan="eagerlyItem.detail.length">
                                {{ eagerlyItem.exterior }}
                              </td>
                              <td :rowspan="eagerlyItem.detail.length">
                                {{ eagerlyItem.singleWeight }}
                              </td>
                            </tr>
                            <tr v-else>
                              <td style="border-left: none">
                                {{ detailItem.time }}
                              </td>
                              <td>{{ detailItem.insp_op }}</td>
                              <td>{{ detailItem.inspItem }}</td>
                              <td>{{ detailItem.stdValue }}</td>
                              <td>{{ detailItem.inspValue }}</td>
                              <td>{{ detailItem.result }}</td>
                            </tr>
                          </template>
                        </template>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div>
                  <p :style="titleTextStyle">淬水資訊</p>
                  <commonTable
                    :fields="listData.quenchingWaterFields"
                    :items="item.quenchingWaterItems"
                  >
                  </commonTable>
                </div>
              </div>
            </template>
          </template>
          <!-- </div> -->
        </div>

        <div>
          <p :style="titleTextStyle">使用模具資訊</p>
          <commonTable
            :fields="listData.useMoldFields"
            :items="listData.useMoldItems"
          >
            <template #cell(useLife)="data">{{
              isNaN(Number(data.value))
                ? data.value
                : Number(data.value).toLocaleString("en-US")
            }}</template>
          </commonTable>
        </div>

        <div style="page-break-inside: avoid">
          <p :style="titleTextStyle">爐具資訊</p>
          <div style="">
            <!-- 保溫爐 -->
            <div
              v-if="stoveTabData2200.length != 0"
              style="margin-bottom: 1rem"
            >
              <div style="margin-bottom: 1rem">
                <div :style="titleTextStyle">
                  <span>保溫爐-溫度曲線圖</span>
                </div>
                <div>
                  <template v-for="(item, key) in stoveTabData2200">
                    <img
                      v-if="
                        chartsUrl['print-temperatureCurve-chart-2200-' + key]
                      "
                      :src="
                        chartsUrl['print-temperatureCurve-chart-2200-' + key]
                      "
                      alt="Chart Image"
                      style="
                        height: 250px;
                        width: 100%;
                        object-fit: contain;
                        display: block;
                        page-break-inside: avoid;
                      "
                    />
                    <div>({{ item.name }})</div>
                  </template>
                  <div
                    v-for="(item, key) in stoveTabData2200"
                    :id="'print-temperatureCurve-' + key"
                    style="width: 900px; height: 250px"
                    class="print-temperatureCurve-chart-hide"
                  >
                    <chart
                      :chartId="'print-temperatureCurve-chart-2200-' + key"
                      :styleGroup="{
                        width: '900px',
                        height: '250px',
                        background: '#fff',
                      }"
                      :chartData="item.chartData"
                      :chartType="'customize'"
                    />
                  </div>
                </div>
              </div>
              <commonTable
                :fields="listData.stoveFields"
                :items="listData.stoveTabData[2200].stoveItems"
              >
              </commonTable>
            </div>
            <!-- 環形爐 -->
            <div v-if="listData.stoveTabData[22103]">
              <div class="row mx-0">
                <div class="col-12 workOrderHistoryList-paragraph">
                  <div :style="titleTextStyle">
                    <span>環形爐-溫度紀錄</span>
                  </div>
                  <whdAnnularTemp
                    :tempData="listData.stoveTabData[22103].whdAnnularTempData"
                  />
                </div>
              </div>
            </div>
            <!-- 加熱爐 -->
            <div v-if="stoveTabData2210.length != 0">
              <div style="margin-bottom: 1rem">
                <div :style="titleTextStyle">
                  <span>加熱爐-溫度曲線圖</span>
                </div>
                <div>
                  <template v-for="(item, key) in stoveTabData2210">
                    <img
                      v-if="
                        chartsUrl['print-temperatureCurve-chart-2210-' + key]
                      "
                      :src="
                        chartsUrl['print-temperatureCurve-chart-2210-' + key]
                      "
                      alt="Chart Image"
                      style="
                        height: 250px;
                        width: 100%;
                        object-fit: contain;
                        display: block;
                        page-break-inside: avoid;
                      "
                    />
                    <div>({{ item.name }})</div>
                  </template>
                  <div
                    v-for="(item, key) in stoveTabData2210"
                    :id="'print-temperatureCurve-' + key"
                    style="width: 900px; height: 250px"
                    class="print-temperatureCurve-chart-hide"
                  >
                    <chart
                      :chartId="'print-temperatureCurve-chart-2210-' + key"
                      :styleGroup="{
                        width: '900px',
                        height: '250px',
                        background: '#fff',
                      }"
                      :chartData="item.chartData"
                      :chartType="'customize'"
                    />
                  </div>
                </div>
              </div>
              <commonTable
                :fields="listData.stoveFields"
                :items="listData.stoveTabData[2210].stoveItems"
              >
                <template #cell(item)="data">{{ data.index + 1 }}</template>
              </commonTable>
            </div>
            <!-- 退火爐 -->
            <div v-if="stoveTabData2230.length != 0">
              <div style="margin-bottom: 1rem">
                <div :style="titleTextStyle">
                  <span>退火爐-溫度曲線圖</span>
                </div>
                <div>
                  <template v-for="(item, key) in stoveTabData2230">
                    <img
                      v-if="
                        chartsUrl['print-temperatureCurve-chart-2230-' + key]
                      "
                      :src="
                        chartsUrl['print-temperatureCurve-chart-2230-' + key]
                      "
                      alt="Chart Image"
                      style="
                        height: 250px;
                        width: 100%;
                        object-fit: contain;
                        display: block;
                        page-break-inside: avoid;
                      "
                    />
                    <div>({{ item.name }})</div>
                  </template>
                  <div
                    v-for="(item, key) in stoveTabData2230"
                    :id="'print-temperatureCurve-' + key"
                    style="width: 900px; height: 250px"
                    class="print-temperatureCurve-chart-hide"
                  >
                    <chart
                      :chartId="'print-temperatureCurve-chart-2230-' + key"
                      :styleGroup="{
                        width: '900px',
                        height: '250px',
                        background: '#fff',
                      }"
                      :chartData="item.chartData"
                      :chartType="'customize'"
                    />
                  </div>
                </div>
              </div>
              <commonTable
                :fields="listData.stoveFields"
                :items="listData.stoveTabData[2230].stoveItems"
              >
                <template #cell(item)="data">{{ data.index + 1 }}</template>
              </commonTable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch, inject, provide } from "vue";
import { useStore } from "vuex";
import commonTable from "@/components/commonTable.vue";
import temperatureCurve from "@/components/temperatureCurve.vue";
import chart from "@/components/chart.vue";
import whdAnnularTemp from "@/components/workOrderHistoryList/whdAnnularTemp.vue";
export default {
  components: { commonTable, temperatureCurve, chart, whdAnnularTemp },
  name: "printOutWorkOrderHistoryList",
  setup() {
    const store = useStore();
    const listData = inject("listData");
    const print = ref(null);
    const chartsUrl = ref({});
    console.log(listData.value);
    const stoveTabData2200 = ref([]);
    const stoveTabData2210 = ref([]);
    const stoveTabData2230 = ref([]);
    provide("chartsUrl", chartsUrl);

    const methods = {
      setTimeoutAlert: (alertText) => {
        store.dispatch("commonAlert/setTimeoutAlert", [alertText]);
      },
    };

    const printTitleStyle = {
      "font-weight": "bold",
      "font-size": "26px",
    };
    const titleTextStyle = {
      "margin-bottom": "0px",
      "text-align": "left",
    };

    const printData = () => {
      console.log(chartsUrl.value);
      if (Object.keys(listData.value).length == 0) {
        methods.setTimeoutAlert("無法匯出，請通知系統人員");
        return;
      }
      const printPage = window.open("", "Printing...", "");
      // Add your CSS styles
      let str = "*{text-align: center; font-family: DFKai-sb;}";
      str +=
        "table{width: 100% !important; white-space: pre-wrap;border-collapse: collapse;}";
      str += "th,td{border: 2px solid #000; padding:0px;height: 2.5rem;}";
      str += `@media print { .print-temperatureCurve-chart-hide {display: none;}}`;
      printPage.document.open();
      printPage.document.write("<HTML><head></head>");
      printPage.document.write("<style>" + str + "</style>");
      printPage.document.write('<BODY onload="window.print();window.close()">');
      printPage.document.write(print.value.innerHTML);
      printPage.document.close("</BODY></HTML>");
    };

    // 數值轉換成中文
    const convertToTraditionalChineseNumber = (number) => {
      const chineseNumberMap = {
        0: "零",
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
        7: "七",
        8: "八",
        9: "九",
      };

      return String(number)
        .split("")
        .map((digit) => chineseNumberMap[digit])
        .join("");
    };
    const getAreaGroup = (data, areaQty) => {
      let temperatureArray = [];
      let timeArray = [];
      if (data.std_heat_param == null || data.std_heat_param == "") {
        return;
      }
      [temperatureArray, timeArray] = getStdChartValue(data.std_heat_param);

      var areaGroup = [];

      for (let i = 1; i <= areaQty; i++) {
        var area = {
          name: convertToTraditionalChineseNumber(i) + "區",
          chartData: {
            animation: false,
            grid: {
              top: "10%",
              left: "3%",
              right: "4%",
              bottom: "5%",
              containLabel: true,
            },
            xAxis: [
              {
                type: "category",
                data: timeArray,
                splitLine: { show: false },
                axisPointer: {
                  type: "shadow",
                },
              },
            ],
            yAxis: {
              type: "value",
              // name: "單位 溫度",
              minInterval: 1,
              scale: true,
            },
            series: [
              // 標準值
              {
                data: temperatureArray,
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#aaaaaa",
                  width: 4,
                },
              },
              // 實際值
              {
                data: [],
                type: "line",
                showSymbol: false,
                lineStyle: {
                  color: "#e78500",
                  width: 4,
                },
              },
            ],
          },
        };
        areaGroup.push(area);
        let key = "temp" + i;
        if (data.act_heat_param.hasOwnProperty(key)) {
          areaGroup[areaGroup.length - 1].chartData.series[1].data =
            Object.values(data.act_heat_param[key]);
          // console.log( Object.values(data.act_heat_param[key]));
        }
      }
      console.log(areaGroup);

      return areaGroup;
    };
    // 取得溫度曲線圖-標準值資料
    const getStdChartValue = (data) => {
      let temperatureArray = [];
      let timeArray = [];
      let currentTemp = 0;
      let currentTime = 0;

      let decimalPlaces = getMaxDecimalPlaces(data);
      data.forEach((item) => {
        let timeSteps = item.hours * Math.pow(10, decimalPlaces);
        let tempIncrementPerStep = 0;

        if (item.status === "K") {
          // 如果是持續類型，直接將溫度添加到數組
          currentTemp = item.temp;
        } else if (item.status === "H") {
          // 如果是移動類型，計算溫度的增量和每小時增加的溫度值
          let tempDiff = item.temp - currentTemp;
          tempIncrementPerStep = tempDiff / timeSteps;
        }

        for (let t = 0; t < timeSteps; t++) {
          currentTemp += tempIncrementPerStep;
          currentTemp = Math.min(currentTemp, item.temp); // 確保不超過目標溫度
          temperatureArray.push(currentTemp);
          currentTime += 1 / Math.pow(10, decimalPlaces);
          timeArray.push(currentTime.toFixed(decimalPlaces));
        }
      });
      return [temperatureArray, timeArray];
    };
    // 取得最長小數點位數
    const getMaxDecimalPlaces = (data) => {
      let maxDecimalPlaces = 0;
      data.forEach((item) => {
        let decimalPlaces = getDecimalPlaces(item.hours);
        if (decimalPlaces > maxDecimalPlaces) {
          maxDecimalPlaces = decimalPlaces;
        }
      });
      return maxDecimalPlaces;
    };
    // 取得小數點位數
    const getDecimalPlaces = (num) => {
      let decimalPlaces = 3; //要保留的小數位數
      let multiplier = 10 ** decimalPlaces;
      num = Math.round(num * multiplier) / multiplier;
      let match = ("" + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
      if (!match) return 0;
      return Math.max(
        0,
        (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0)
      );
    };
    const commonMethods = {
      convertToTraditionalChineseNumber: convertToTraditionalChineseNumber,
      getAreaGroup: getAreaGroup,
    }; // 取得溫度曲線圖資料

    watch(listData, (newValue) => {
      if (listData.value.stoveTabData) {
        if (listData.value.stoveTabData[2200]) {
          stoveTabData2200.value = commonMethods.getAreaGroup(
            listData.value.stoveTabData[2200].areaGroup,
            listData.value.stoveTabData[2200].areaQty
          );
        }
        if (listData.value.stoveTabData[2210]) {
          stoveTabData2210.value = commonMethods.getAreaGroup(
            listData.value.stoveTabData[2210].areaGroup,
            listData.value.stoveTabData[2210].areaQty
          );
        }
        if (listData.value.stoveTabData[2230]) {
          stoveTabData2230.value = commonMethods.getAreaGroup(
            listData.value.stoveTabData[2230].areaGroup,
            listData.value.stoveTabData[2230].areaQty
          );
        }
      }
    });
    return {
      listData,
      commonMethods,
      print,
      stoveTabData2200,
      stoveTabData2210,
      stoveTabData2230,
      chartsUrl,
      printTitleStyle,
      titleTextStyle,
      printData,
    };
  },
};
</script>

<style scoped>
button {
  border: 0px;
  border-radius: 5px;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
  padding: 0 13px;
  width: 4.25rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0 0 0 1.5rem;
  cursor: pointer;
}
</style>
